<script lang="ts" setup>
import ContactInfo from '../../components/ContactInfo.vue'
import CategoryItem from '../../components/CategoryItem.vue'
const lists = ref([
  {
    image: './images/services/repair.jpg',
    title: '產品維修',
    link: '/services/repair',
    rotate: 0
  },
  {
    image: './images/services/search.jpg',
    title: '服務進度查詢',
    link: '/member/service',
    rotate: '-45'
  }
])
</script>

<template>
  <div class="contact">
    <div class="contact__left">
      <Intro subtitle="contact" :data="{
        title: '聯絡我們'
      }" />
    </div>
    <div class="contact__right">
      <div class="contact__right__info">
        <ContactInfo />
      </div>
      <div class="contact__right__lists">
        <ul class="lists">
          <li v-for="(item, index) in lists" :key="index">
            <CategoryItem :data="{ ...item }" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.contact {
  @include grid(8, 24);
  margin-bottom: toRem(210);

  @include max-media(900) {
    margin-bottom: toRem(30);
  }

  &__left {
    grid-column: 1 / span 2;

    @include max-media(800) {
      grid-column: 1 / span 8;
    }
  }

  &__right {
    @include grid(6, 24);
    grid-column: 3 / span 6;
    padding-top: toRem(15);

    @include max-media(800) {
      grid-column: 1 / span 8;
    }

    @include max-media(560) {
      padding-top: 0;
    }

    &__info {
      grid-column: 1 / span 2;

      @include max-media(560) {
        grid-column: 1 / span 6;
      }
    }

    &__lists {
      grid-column: 3 / span 4;

      @include max-media(560) {
        grid-column: 1 / span 6;
      }
    }
  }

  .intro {
    text-align: left;

    :deep(.intro__subtitle) {
      font-size: toRem(60);
    }
  }

  .lists {
    display: flex;
    justify-content: space-between;

    li {
      width: calc((100% - toRem(24)) / 2);
    }
  }
}
</style>
